// services/fetchNotification.js
export const fetchNotification = async (url) => {
    try {
        const response = await fetch(url, {
            method: "GET",
            credentials: "include", // send session cookie
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        if (!response.ok) {
            // return structured error to caller
            return { success: false, message: data.message || "Failed to fetch" };
        }

        // expected response shape from backend: { success: true, notification, total, page, totalPages }
        return data;
    } catch (error) {
        console.error("Fetch Notification Error:", error);
        return { success: false, message: error.message || "Network error" };
    }
};